<template>
  <div
    id="order-template-config"
    class="app-main-content"
    style="flex-grow:1;display:flex;flex-direction:column"
  >
    <div class="app-main-inner-tab" style="flex-grow:1;display:flex;flex-direction:column">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_OceanExport')" name="SeaExportTemplate">
          <order-template ref="orderTemplate" lob="SE" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_OceanImport')" name="SeaImportTemplate">
          <order-template ref="orderTemplate" lob="SI" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_AirExport')" name="AirExportTemplate">
          <order-template ref="orderTemplate" lob="AE" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_AirImport')" name="AirImportTemplate">
          <order-template ref="orderTemplate" lob="AI" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_RailwayBusiness')" name="RailwayBussiness">
          <order-template ref="orderTemplate" lob="RB" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_FbaOrder')" name="FbaImportTemplate">
          <order-template ref="orderTemplate" lob="FBA" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_FbaSea')" name="FbaSeaImportTemplate">
          <order-template ref="orderTemplate" lob="FBA_SE" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_FbaAir')" name="FbaAirExportTemplate">
          <order-template ref="orderTemplate" lob="FBA_AE" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_FbaRailway')" name="FbaRailwayBussiness">
          <order-template ref="orderTemplate" lob="FBA_RE" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import OrderTemplate from './components/orderTemplateConfig/orderTemplate'

export default {
  name: 'ImportOrderTemplateConfig',
  components: { OrderTemplate },
  data() {
    return {
      loading: false,
      activeTabName: 'SeaExportTemplate'
    }
  },
  methods: {
    handClick() {
      this.$refs.orderTemplate.closeShowConfig()
    }
  }
}
</script>

<style lang="scss">
</style>
